import type {Employee} from "../../domain/entities/employee.entity";

/**
 * The name shown under the sidebar's "Einstellungen" button (Anke,
 * 2026-09-18). `appState.user` only ever carries `username`/`uid` — the
 * actual name lives on the linked `Employee` (`Employee.name`, "Nachname,
 * Vorname" — the format already used everywhere else an employee's name is
 * displayed, e.g. `ha-issue-preview`/`ha-tooltip`). Falls back to the bare
 * username when no Employee is linked, the lookup failed, or the Employee
 * has no name at all, and to an empty string when neither is available, so
 * the caller can treat that as "render nothing".
 *
 * A nameless Employee yields `''` from `Employee.name` (formatPersonName
 * joins only non-blank parts). The check for "nothing but separators" stays
 * as a guard for callers that hand in a pre-built name.
 */
export function resolveUserDisplayName(employee: Employee | null, username: string | null): string {
    const name = employee?.name?.trim() ?? '';
    if (name.replace(/[,\s]/g, '') !== '') {
        return name;
    }
    return username || '';
}
